import React, { useEffect } from "react";
import "./Testimonials.css";
import { TestimonialCard } from "./"; // Import from index.ts in the same directory

const testimonialData = [
  {
    id: 1,
    text: "This program completely changed my life. I never thought I could achieve these results so quickly. The transformation has affected every aspect of my life.",
    name: "Jaylen",
    title: "Professional Basketball player",
    imageId: 1,
  },
  {
    id: 2,
    text: "I was skeptical at first, but the results speak for themselves. This is the best investment I've made in myself in years. Truly life-changing!",
    name: "David",
    title: "Construction Project Manager",
    imageId: 2,
  },
  {
    id: 3,
    text: "The transformation wasn't just physical - it changed my mindset completely. I'm now approaching every aspect of my life with newfound confidence.",
    name: "Saydul",
    title: "Cyber Security Expert",
    imageId: 3,
  },
  {
    id: 4,
    text: "I've tried everything before this program, but nothing gave me sustainable results. This approach is different - it's comprehensive and actually works!",
    name: "Joseph",
    title: "Software Engineer",
    imageId: 4,
  },
  {
    id: 5,
    text: "The step-by-step guidance made all the difference. I finally achieved the results I've been chasing for years. This program delivers on its promises.",
    name: "Chibeze",
    title: "Professional Boxer",
    imageId: 5,
  },
  {
    id: 6,
    text: "I was at a crossroads in my life when I found this program. The transformation has been remarkable. I'm grateful every day for taking that first step.",
    name: "Henry",
    title: "Games Developer",
    imageId: 6,
  },
];

const Testimonials: React.FC = () => {
  useEffect(() => {
    const cards = document.querySelectorAll(".testimonial-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            (entry.target as HTMLElement).style.transition =
              "opacity 0.6s ease, transform 0.6s ease";
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    cards.forEach((card) => {
      observer.observe(card);
    });

    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, []);

  return (
    <section id="testimonials" className="testimonials">
      <h2 className="testimonial-heading">Transformational Results</h2>
      <div className="testimonial-grid">
        {testimonialData.map((testimonial) => (
          <TestimonialCard
            key={testimonial.id}
            text={testimonial.text}
            name={testimonial.name}
            title={testimonial.title}
            imageId={testimonial.imageId}
          />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
